import { ThemeServiceInterface } from "./types/themeService.interface"
import { CustomTheme } from "./types/customTheme.interface"
import { ModeEnum } from "./types/mode.enum"
import { Realm } from "../realms/types/realm.interface"
import { HttpRequest } from "./util/httpRequest"
import mergeObjects from "./util/mergeObject"

export class ThemeService implements ThemeServiceInterface {
    casAppName?: string
    defaultMode: ModeEnum
    realm?: string
    httpRequest: HttpRequest

    private theme: CustomTheme

    constructor(theme: CustomTheme) {
        this.theme = theme
        this.defaultMode = theme.defaultMode
        this.realm = theme.applicationConsumerInformation.realm ?? "hotmart"
        this.casAppName = theme.applicationConsumerInformation.casAppName
        this.httpRequest = new HttpRequest("")
    }

    private removeEmpty(realm: Realm): Partial<Realm> {
        if (!realm) return {} as Partial<Realm>
        const realmFiltered = Object.entries(realm).filter(
            ([, value]) => value !== undefined && value !== null && value !== ""
        )
        return Object.fromEntries(realmFiltered) as Partial<Realm>
    }

    private async getAppTemplate(): Promise<Realm> {
        if (!this.casAppName) return {} as Realm

        return await this.httpRequest.get<Realm>(
            `./themes/custom/dist/${this.casAppName}/template.json`
        )
    }

    private async getRealmTemplate(): Promise<Realm> {
        return await this.httpRequest.get<Realm>(
            `./themes/custom/dist/${this.realm}/template.json`
        )
    }

    private normalize(realm: Realm): Realm {
        return { ...realm, mode: realm.mode?.toLowerCase() } as Realm
    }

    get brand() {
        return this.theme.brand
    }

    async getThemeSettings(): Promise<Realm> {
        const realTemplate = await this.getRealmTemplate()
        const appTemplate = await this.getAppTemplate()
        const customizations = await this.theme.getTheme()

        const mergedTemplates = mergeObjects.deepMerge<Realm, Partial<Realm>>(
            realTemplate,
            appTemplate
        )

        const customizationsMerged = mergeObjects.deepMerge<
            Realm,
            Partial<Realm>
        >(mergedTemplates, this.removeEmpty(customizations as any as Realm))

        return this.normalize(customizationsMerged)
    }
}
